import { render, staticRenderFns } from "./dialog.label.vue?vue&type=template&id=8418a426&"
import script from "./dialog.label.vue?vue&type=script&lang=js&"
export * from "./dialog.label.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports